:host {
  --aha-switch--size: 1em;
  --aha-switch--color: var(--theme-secondary-text);
  --aha-switch--border-color: var(--aha-switch--color);
  --aha-switch--border-width: 2px;
  --aha-switch--border: var(--aha-switch--border-width) solid var(--aha-switch--border-color);
  --aha-switch--width: calc(var(--aha-switch--size) * 2);
  --aha-switch--gap: 1.5ch;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(--aha-switch--gap);
  box-sizing: border-box;
  white-space: nowrap;
}
* {
  box-sizing: border-box;
}
:host(:focus-visible) {
  outline: none;
}
:host(:not([disabled]):hover) #switch,
:host(:focus-within) #switch {
  box-shadow: var(--box-shadow-focus-ring);
}
:host([disabled]) {
  cursor: not-allowed;
}
:host #switch {
  display: inline-flex;
  border: var(--aha-switch--border);
  width: var(--aha-switch--width);
  height: var(--aha-switch--size);
  border-radius: var(--aha-switch--size);
  position: relative;
  transition: all 0.1s ease-in;
  background-color: var(--aha-switch--color);
}
:host #handle {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--aha-switch--size) - (2 * var(--aha-switch--border-width)));
  height: calc(var(--aha-switch--size) - (2 * var(--aha-switch--border-width)));
  background-color: var(--theme-primary-background);
  border-radius: 50%;
  transition: all 0.1s ease-in;
}
:host #slots {
  user-select: none;
  display: inline-flex;
  gap: calc(var(--aha-switch--gap) / 2);
}
:host #slots[hidden] {
  display: none;
}
:host slot[name='active'] {
  display: none;
}

:host([active]) {
  --aha-switch--color: var(--theme-button-success);
}
:host([active]) #handle {
  left: calc(100% - var(--aha-switch--size) + (2 * var(--aha-switch--border-width)));
}
:host([active]) #slots slot[name='active'] {
  display: unset;
}
:host([active]) slot[name='inactive'] {
  display: none;
}
[hidden] {
  display: none !important;
}
